// @flow

import * as React from 'react';
import { Box } from 'react-system';
import { graphql, useFragment } from 'react-relay';
import { useRouter, useRouterChanging } from '../../controls/router';
import {
  AggregatesListingCard,
  useGridLoadingStyle,
} from './AggregatesListingCard';
import { offerTypeDescriptor } from './Filters/sharedDescriptors';
import { useActions } from './state';
import type { AggregatesListingsSimilarItems_aggregatesListings$key } from './__generated__/AggregatesListingsSimilarItems_aggregatesListings.graphql';

type Props = {|
  aggregatesListings: ?AggregatesListingsSimilarItems_aggregatesListings$key,
|};

export const AggregatesListingsSimilarItems = (props: Props): React.Node => {
  const aggregatesListings = useFragment(
    graphql`
      fragment AggregatesListingsSimilarItems_aggregatesListings on AggregatesListingConnectionConnection {
        similarItems {
          ...AggregatesListingCard_listing
        }
      }
    `,
    props.aggregatesListings,
  );

  const changing = useRouterChanging();
  const router = useRouter();
  const loadingGridStyle = useGridLoadingStyle();

  const [{ offerType }] = offerTypeDescriptor.useState();
  const { onListingCardShowPopup, onListingCardHidePopup } = useActions();

  const similarItems = aggregatesListings?.similarItems ?? null;

  return similarItems == null ? null : (
    <Box
      pt={3}
      pb={[3, 4]}
      css={[
        changing?.match.pathname === router.pathname &&
          changing?.match.query.listingSlug == null &&
          router.query.listingSlug == null &&
          loadingGridStyle,
        {
          display: 'grid',
          gridTemplateColumns: `repeat(auto-fill, minmax(240px, 1fr))`,
          gridGap: '16px',
          alignContent: 'start',
        },
      ]}
    >
      {similarItems.map((item, i) => {
        return (
          <AggregatesListingCard
            key={i}
            listing={item}
            offerType={offerType}
            titleComponent="h2"
            withStructuredData={true}
            isSimilar={true}
            onListingCardShowPopup={onListingCardShowPopup}
            onListingCardHidePopup={onListingCardHidePopup}
            shallowLink={true}
            replaceLink={false}
          />
        );
      })}
    </Box>
  );
};
